import React from 'react';

type FetchingAnimationProps = {
	width: number | string;
	height: number;
	textSize?: number;
	borderRadius?: number;
	marginBottom?: number;
	marginLeft?: number;
	marginRight?: number;
	maxWidth?: boolean;
	marginTop?: number;
	customStyles?: React.CSSProperties;
	delay?: 0 | 1 | 2 | 3 | 4; // Animation delay (0 = no delay, 1-4 = staggered delays)
}
/**
 * FetchingAnimation component
 * 
 * Renders a loading animation indicating data is being fetched
 * Supports staggered animation delays for better loading UX
 * 
 * @param delay - Animation delay variant (0-4), creates staggered pulse effect
 * @returns 
 */
const FetchingAnimation: React.FC<FetchingAnimationProps> = ({
	width,
	height,
	textSize,
	borderRadius,
	marginBottom,
	marginLeft,
	maxWidth,
	marginTop,
	marginRight,
	customStyles,
	delay = 0
}) => {
	let maxWidthValue = maxWidth ? '100%' : 'initial';
	let widthValue = typeof width !== 'number' ? `${width}%` : width;
	let heightValue = `${height}px`;
	let borderRadiusValue = borderRadius ? `${borderRadius}px` : undefined;
	let marginTopValue = marginTop ? `${marginTop}px` : undefined;
	let marginBottomValue = marginBottom ? `${marginBottom}px` : undefined;
	let marginLeftValue = marginLeft ? `${marginLeft}px` : undefined;
	let marginRightValue = marginRight ? `${marginRight}px` : undefined;

	const className = delay > 0 ? `fetching-animation fetching-animation--delay-${delay}` : 'fetching-animation';

	return (
		<div
			className={className}
			style={{ width: widthValue, height: heightValue, fontSize: textSize, borderRadius: borderRadiusValue, marginBottom: marginBottomValue, marginLeft: marginLeftValue, marginRight: marginRightValue, maxWidth: maxWidthValue, marginTop: marginTopValue, ...customStyles }}
		>
			{/* Empty loading element */}
		</div>
	)
}

export default FetchingAnimation;